import { create } from 'zustand'

interface CognitoStoreType {
  cognito_captcha_api_key: string
  setCaptchaApiKey: (data: string) => void
}

export const useCognitoStore = create<CognitoStoreType>((set, get) => ({
  cognito_captcha_api_key: '',
  setCaptchaApiKey: (data: any) => {
    set({ cognito_captcha_api_key: data })
  }
}))
